import { render, staticRenderFns } from "./swallowClick.vue?vue&type=template&id=498d59e0&"
import script from "./swallowClick.vue?vue&type=script&lang=js&"
export * from "./swallowClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498d59e0')) {
      api.createRecord('498d59e0', component.options)
    } else {
      api.reload('498d59e0', component.options)
    }
    module.hot.accept("./swallowClick.vue?vue&type=template&id=498d59e0&", function () {
      api.rerender('498d59e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/swallowClick.vue"
export default component.exports